import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import Etiquetas1 from '../imagens/LancEtiquetas/Etiquetas1.png';
import Etiquetas2 from '../imagens/LancEtiquetas/Etiquetas2.png';
import Etiquetas3 from '../imagens/LancEtiquetas/Etiquetas3.png';
import Etiquetas4 from '../imagens/LancEtiquetas/Etiquetas4.png';
import Etiquetas5 from '../imagens/LancEtiquetas/Etiquetas5.png';
import Etiquetas6 from '../imagens/LancEtiquetas/Etiquetas6.png';


export default class Etiquetas extends Component {

    render() {

        const { isOpen, onClose } = this.props;

        return (
            <Modal
                title="Como fazer a Impressão de Etiquetas"
                className="modal"
                visible={isOpen}
                destroyOnClose
                onCancel={onClose}
                footer={null}
                width="50%"
                style={{ top: 10 }}
            >
                <Row>
                    <Col xs={24}>
                        <p>Para acessar a impressão de etiquetas:  </p>

                        <div className="image-wrapper">
                            <img className="img_smaller" src={Etiquetas1} alt="Etiqueta 1" />
                        </div>

                        <div className="gray_bar"></div>

                        <div className="image-wrapper">
                            <img src={Etiquetas2} alt="Etiqueta 2" />
                        </div>

                        <h3>Na tela de Etiquetas nós temos:</h3>
                        <ol>
                            <li>Botão para abrir a impressão das etiquetas.</li>
                            <li>Posição das etiquetas.</li>
                            <li>Produto a ser adicionado a lista de impressão.</li>
                            <li>Grupo de produtos a ser adicionado a impressão.</li>
                            <li>Tabela mostrando os produtos na lista para impressão.</li>
                        </ol>

                        <div className="gray_bar"></div>

                        <h3>Como adicionar produtos e fazer a impressão da etiqueta</h3>

                        <p>
                            Primeiramente, o gestor precisa adicionar os produtos aos quais ele desejar imprimir as etiquetas. 
                            Caso o gestor queira adicionar apenas um produto a lista, basta escolher o produto no campo de Produto e depois clicar no botão +.
                        </p>

                        <div className="image-wrapper">
                            <img src={Etiquetas3} alt="Etiqueta 3" />
                        </div>

                        <p>
                            Caso o gestor queira adicionar vários produtos a lista de uma vez só, basta ele escolher o Grupo de produtos no campo Grupos e clicar 
                            no botão +. Isso irá adicionar todos os produtos daquele grupo a lista de impressão.
                        </p>

                        <div className="image-wrapper">
                            <img src={Etiquetas4} alt="Etiqueta 4" />
                        </div>

                        <div className="gray_bar"></div>

                        <h3>Diminuir/Aumentar quantidade de etiquetas de um produto</h3>

                        <p>
                            Caso o gestor precise imprimir mais de uma etiqueta do mesmo produto, basta utilizar as opções auxiliares na tabela de produtos a serem imprimidos
                            para aumentar a quantidade de etiquetas do produto.
                        </p>

                        <div className="image-wrapper">
                            <img src={Etiquetas5} alt="Etiqueta 5" />
                        </div>

                        <div className="gray_bar"></div>

                        <h3>Como definir a posição das etiquetas</h3>

                        <p>
                            A impressão de etiquetas está definida para uma folha de etiquetas com 65 etiquetas, sendo 13 linhas com 5 colunas na folha na posição retrato. 
                            O campo "Posição da Etiqueta" define qual posição as etiquetas irão começar a serem impressas. Por exemplo, se você definir no campo Posição da
                            Etique que as etiquetas começam na posição 5, o sistema irá pular as 4 primeiras posições das etiquetas nas folhas, indo linha por linha da esquerda
                            para a direita. A imagem abaixo mostra o exemplo citado.
                        </p>

                        <div className="image-wrapper">
                            <img src={Etiquetas6} alt="Etiqueta 6" />
                        </div>                        

                    </Col>
                </Row>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/tutoriais/LancEtiqueta.js